import React from 'react';

const ShopModeBanner: React.FC = () => {
  if (import.meta.env.VITE_SHOP_MODE !== 'sandbox') return null;
  return (
    <div className="shop-sandbox-banner" role="status">
      <strong>Sandbox</strong> — test cards only. No charge. Nothing ships. Use 4242 4242 4242 4242, any future date, any CVC.
    </div>
  );
};

export default ShopModeBanner;
